import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getContinueWatching } from '../../redux/actions/history'
import Section from '../Section/Section'

const ContinueWatchingSection = () => {
  const dispatch = useDispatch()
  const continueWatchingData = useSelector(
    state => state.history.continueWatching
  )
  const authState = useSelector(state => state.auth)
  const token = authState.token
  useEffect(() => {
    if (token) {
      dispatch(getContinueWatching())
    }
  }, [dispatch, token])

  if (!continueWatchingData || !continueWatchingData.length) return null
  return (
    <Section
      name={'Continue Watching'}
      sectionData={continueWatchingData}
      allowSeeAll={false}
      topSection={true}
    />
  )
}

export default ContinueWatchingSection
